export default "__VITE_ASSET__CeiDNlT3__"